export default __webpack_public_path__ + "static/media/attacheCase.5ec3c5b6.svg";